var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider2"},[_c('vue-flux',{staticClass:"custome-slide",attrs:{"options":_vm.vfOptions,"transitions":_vm.vfTransitions,"images":_vm.vfImages,"captions":_vm.vfCaptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }